import { IStudent } from '@wot/typings';
import xhr from '../utils/fetch';

export type IStudentStatus = 'active' | 'inactive' | 'blocked';

export interface updateStudentData {
  email?: string;
  profilePic?: string;
  name?: string;
  phoneNumber?: string;
  preference?: {
    timezone: string;
    currency: string;
    lessonUpdates: boolean;
    accountUpdates: boolean;
  };
  address?: {
    area: string;
    town: string;
    state: string;
    pincode: string;
    country: string;
  };
  status?: string;
}

const get = async (status: IStudentStatus | undefined): Promise<IStudent[]> => {
  return await xhr({
    url: `/a/users?status=${status || ''}`,
    method: 'GET'
  })
    .then((res) => res.data)
    .catch((err) => {
      throw err;
    });
};

const getAll = async (
  currentPage: number,
  resultsPerPage: number,
  filters: any,
  sortBy: any
): Promise<{ count: number; data: IStudent[] }> => {
  const res = await xhr({
    url: `/a/students`,
    method: 'GET',
    params: {
      resultsPerPage: resultsPerPage.toString(),
      page: currentPage.toString(),
      ...filters,
      ...sortBy
    }
  });
  if (res.status === 'OK') {
    return res.data;
  } else {
    throw Error(res.message);
  }
};

const updateStudent = async (id: string, data: updateStudentData) => {
  return await xhr({
    url: `/u/users`,
    method: 'PUT',
    body: { _id: id, data }
  })
    .then((res) => res.data)
    .catch((err) => {
      throw err;
    });
};

const getStudentProfile = async (studentId: string) => {
  return await xhr({
    url: `/u/users`,
    method: 'GET',
    params: {
      _id: studentId
    }
  })
    .then((res) => res.data)
    .catch((err) => {
      throw err;
    });
};

const studentsApi = {
  get,
  updateStudent,
  getStudentProfile,
  getAll
};

export default studentsApi;
